<template>
  <Badge :status="statusColor" :title="statusDetail">
    {{ statusName }}
  </Badge>
</template>

<script setup>
import { defineProps, ref, computed, watchEffect } from 'vue';
import { Badge } from '@stakeui';

const props = defineProps({
  meeting: {
    type: Object,
  },
  statusName: {
    type: String,
  },
});

const statusColor = computed(() => {
  const COLORS = {
    "Scheduled": 'info',
    "Bot Scheduled": 'info',
    "Upcoming": 'info',
    "Uploading": 'warning',
    "Processing": 'warning',
    "Completed": 'success',
    "Failed": 'danger',
  };

  if (props.statusName) {
    return COLORS[props.statusName] ?? '';
  }

  return COLORS[props.meeting.status] ?? '';
})

const statusDetail = computed(() => {
  if (!props.meeting) {
    return '';
  }

  const MESSAGES = {
    timeout_exceeded_noone_joined: 'Nobody joined the meeting',
    call_ended_by_platform_waiting_room_timeout: 'Bot was not admitted from the waiting room',
  };

  if (props.meeting.bot_status === 'done') return null;

  if (!props.meeting.bot_status) {
    // TODO: There are few different cases where this can happen
    return null;
  }

  return MESSAGES[props.meeting.bot_status] ?? props.meeting.bot_status;
});
</script>